export enum PeopleFiltersOptions {
    Companies = 'Companies',
    JobTitles = 'JobTitles',
    ExactMatch = 'ExactMatch',
}
